
import { declareVrunComponent } from '/vodalys/vvuejs/declareVrunComponent.mjs'

declareVrunComponent('talktoController.vrun.component', () => import('./components/TalktoController.vue'))
